import styled from "styled-components";
import StyledButton from "./StyledButton";

const StyledClearConversationButton = styled(StyledButton)`
  height: 50px;
  width: 50px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 20px rgb(0 0 0 / 20%);
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 700;
  position: absolute;
  top: 40px;
  right: 40px;
`;

export default StyledClearConversationButton;
